import React, { useState, useEffect } from 'react';
import { Alert, Card, Form, Button } from 'react-bootstrap';
import { HHIEButton } from '../../utility/HHIEButton';
import { HHIECard } from '../../utility/HHIECard';
import { HHIEError } from '../../utility/HHIEError';
import Loading from '../../utility/Loading';

export const RecoverPOCAccount = () => {
    const [loading, setLoading] = useState(false);
    const [expired, setExpired] = useState(false);
    const [question, setQuestion] = useState();
    const [uuidAnswer, setUUIDAnswer] = useState();
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);
    const [disabled, setDisabled] = useState(true);
    useEffect(() => {
        const RetrieveQuestionsIfNotExpired = async (uuid) => {
            setLoading(true);
            if (!uuid || uuid.length > 25 || uuid.length < 15) {
                setExpired(true);
                setLoading(false);
                return;
            }
            const isExpired = await IsUUIDExpired(uuid)
            setExpired(isExpired);
            if (isExpired) {
                setLoading(false);
                console.log("EXPIRED.");
                return;
            }
            // user has already failed more than one question
            const attemptsLeft = await getAllowedAttemptsLeft(uuid);
            if (attemptsLeft <= 0) {
                setExpired(true);
            }
            const questionObj = await getRandomQuestion(uuid);
            setQuestion(questionObj);
            let tempAnswer = {
                uuid: uuid,
                resetQuestionId: 0,
                value: null
            };
            setUUIDAnswer(tempAnswer);
            setLoading(false);
        }
        // BEGIN USEEFFECT
        RetrieveQuestionsIfNotExpired(window.location.search.substring(1).split("=")[1]);
    }, []);

    const IsUUIDExpired = async (uuid) => {
        return fetch('api/POCUser/is-uuid-token-expired/' + uuid)
            .then(async (response) => {
                try {
                    const res = await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                    return res;
                }
                catch (ex) {
                    return console.log(ex);
                }
            })
            .catch(ex => console.log(ex));
    };
    const getRandomQuestion = async (uuid) => {
        return fetch('api/POCUser/get-random-question/' + uuid)
            .then(async (response) => {
                try {
                    if (response.status === 204) {
                        setError(true);
                        setErrorMessage("You don't have any questions to answer.");
                    }
                    const res = await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                    return res;
                }
                catch (ex) {
                    return console.log(ex);
                }
            })
            .catch((ex) => { console.log("response error: " + ex) });
    };
    const handleAnswer = (value, qid) => {
        if (value !== '') { setDisabled(false); }
        let answerObj = uuidAnswer;
        answerObj.resetQuestionId = qid;
        answerObj.value = value;
        setUUIDAnswer(answerObj);
    };
    const getAllowedAttemptsLeft = async (uuid) => {
        //amount-of-failed-questions
        return fetch('api/POCUser/allowed-attempts-left/' + uuid)
            .then(async (attemptsLeftResponse) => {
                try {
                    const res = await attemptsLeftResponse.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    })
                    return res;
                }
                catch (ex) {
                    return console.log(ex);
                }
            })
            .catch((ex) => { console.log("response error: " + ex) });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!uuidAnswer || uuidAnswer.value === null || uuidAnswer.value === "") {
            setError(true);
            setErrorMessage(errorMessagePrompt);
            return;
        }
        const attemptsLeft = await getAllowedAttemptsLeft(uuidAnswer.uuid);
        if (attemptsLeft <= 0) {
            setExpired(true);
        }
        let errorMessagePrompt = "Wrong answer.";

        const requestOptions = {
            method: "POST",
            body: JSON.stringify(uuidAnswer),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        const answerIsCorrect =
            await fetch('api/POCUser/validate-uuid-answer', requestOptions)
                .then(async (response) => {
                    try {
                        return await response.json().then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            return json.message;
                        });
                    } catch (ex) {
                        setError(true);
                        setErrorMessage("DEV Error: " + ex);
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    setError(true);
                    setErrorMessage("DEV Error: " + error);
                    console.log(error);
                }
                );
        if (answerIsCorrect) {
            setSuccess(true);
            //await updatePOCUserCompleteReg();
            setTimeout(() => {
                var link = "/reset-password?u=" + uuidAnswer.uuid;
                window.location.href = link;
            })
        } else {
            let attemptsLeftCopy = attemptsLeft;
            attemptsLeftCopy = attemptsLeftCopy - 1;
            if (attemptsLeftCopy <= 0) {
                setExpired(true);
            }
            if (attemptsLeftCopy > 1) {
                errorMessagePrompt = errorMessagePrompt + " Please try again.";
            }
            if (attemptsLeftCopy === 1) {
                errorMessagePrompt = errorMessagePrompt + " Your account will be locked out if you answer this next question incorrectly.";
            }
            setError(true);
            setErrorMessage(errorMessagePrompt);
            const newQuestion = await getRandomQuestion(uuidAnswer.uuid);
            setQuestion(newQuestion);
        }
    };

    return (
        <>
            {expired &&
                <Alert variant="danger">
                    This page is no longer valid or you have failed too many security questions. Please <HHIEButton id="return-home-btn" title="Return Home" onClick={() => { window.location.href = "/"; }} />
                    <hr />
                    Contact helpdesk@hawaiihie.org via email or call (808) 441-1374 for assistance.
                </Alert>
            }
            {loading && <Loading message="Please wait while we queue your security question..." />}
            {!expired && !loading &&
                <HHIECard>
                    <Card.Title>Answer the following security question to restore your account.</Card.Title>
                    <hr />
                    {question && !error && !success &&
                        <Form onSubmit={handleSubmit}
                        >
                            <Form.Group key={question.id}>
                                <Form.Label>{question.value}</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => {
                                        console.log(e)
                                        handleAnswer(e.target.value, question.id);
                                    }}
                                    onKeyDown={(e) => { if (e.keyCode === 13) handleSubmit() }}
                                />
                                <br />
                                <Button
                                    id="submit-btn"
                                    disabled={disabled}
                                    variant="primary"
                                    size="lg"
                                    style={{ borderRadius: '10px', fontSize: '16px' }}
                                    onClick={handleSubmit}
                                >Submit</Button>
                                
                            </Form.Group>
                        </Form>
                    }
                    {error &&
                        <HHIEError message={errorMsg} onClick={() => { setError(false); setErrorMessage(""); }} />
                    }
                    {success &&
                        <Alert variant="success">Correct. Please wait while we navigate you to reset your password. . .</Alert>
                    }
                </HHIECard>
            }
        </>
    );
}